import { Injectable, inject } from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {animate, AnimationBuilder, AnimationPlayer, style} from '@angular/animations';
import {NavigationEnd, Router} from '@angular/router';

import {filter, take} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class CdkSplashScreenService
{
    private _animationBuilder = inject(AnimationBuilder);
    private _document = inject(DOCUMENT);
    private _router = inject(Router);

    splashScreenEl: any;
    player: AnimationPlayer;



    /**
     * Constructor
     *
     * @param _animationBuilder
     * @param _document
     * @param _router
     */
    constructor()
    {
        // Hide it on the first NavigationEnd event
        this._router.events
            .pipe(
                filter(event => event instanceof NavigationEnd),
                take(1),
            )
            .subscribe(() =>
            {
                this.hide();
            });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Show the splash screen
     */
    show(): void
    {
        this._document.body.classList.remove('cdk-splash-screen-hidden');
    }

    /**
     * Hide the splash screen
     */
    hide(): void
    {
        this._document.body.classList.add('cdk-splash-screen-hidden');
    }
}
